import { createApiResponseSchema, type IAPI } from '../../apiResponse';
import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';

const schema = createApiResponseSchema();

export async function deleteUserDataApi(userId: string): Promise<IValidatedResponse<IAPI>> {
  return deleteRequest<IAPI>({
    path: `/sys/users/${userId}`,
    schema,
  });
}
